import { defineStore } from "pinia";
import { ref, computed, nextTick } from "vue";
import { useRest } from "@/composables/index";

const emptyForm = () => ({
  tipoDocumento: null,
  documento: "",
  gender: { nombre: "" },
  showDocument: "",
  cuil: "",
  apellido: "",
  nombre: "",
  edad: "",
  fechaNacimiento: "",
  nacionalidad: { nombre: "" },
  civilStatus: { nombre: "" },
  domicilio: "",
  telefono: "",
  email: "",
  profesion: "",
  haveStudies: "",
  instruction: { nombre: "" },
  observaciones: "",
  Identikit: [],
  coelsa: [],
});

export const useAffectedStore = defineStore("affected", () => {
  const selected = ref(null);
  const form = ref(emptyForm());
  const formType = ref("view"); // estados del formulario view, edit, create
  const affectedList = ref([]);
  const actuacionID = ref("");
  const rest = useRest();
  const isLoading = ref(false);
  const baseUrl = `${process.env.VUE_APP_BACKEND_ENVIRONMENT}/actuacion-persona-fisica`;

  const fetchAffecteds = async (id, indexToRedirect) => {
    actuacionID.value = id;
    try {
      const url = `${baseUrl}/${id}/afectados`;
      const resp = await rest.get(url);
      affectedList.value = affectedListFormatted(resp.data.data);
      if (indexToRedirect !== undefined) {
        selectNextOrPrevious(indexToRedirect);
      } else {
        selectFirst();
      }
    } catch (e) {
      console.error("Error al traer Afectados", e);
    }
  };

  const affectedListFormatted = (affecteds) => {
    return affecteds.map(function (affected) {
      return {
        ...affected,
        CorreoElectronico: affected.CorreoElectronico || affected.email || "",
        PersonaJuridica: affected.PersonaJuridica || "",
        plataformas: affected.plataformas || [],
        TelefonoJuridico: affected.TelefonoJuridico || "",
        Identikit: affected.Identikit || [],
        coelsa: affected.coelsa || [],
      };
    });
  };

  const validateForm = () => {

    if (form.value.TipoRolPersonaFisicaID?.nombre === "A Determinar") {
      return true;
    }
    const camposObligatorios = [
      "tipoDocumento",
      "documento",
      "gender",
      "showDocument",
      "apellido",
      "nombre",
      "fechaNacimiento",
      "nacionality",
      "civilStatus",
      "domicilio",
      "telefono",
      "email",
      "profesion",
      "haveStudies",
      "instruction",
      "TipoRolPersonaFisicaID",
    ];

    if (form.value.personaJuridica) {
      const camposJuridicos = [
        "cuit",
        "denominacion",
        "domicilioJuridico",
        "telefonoJuridico",
        "rubro",
      ];
      camposObligatorios.push(...camposJuridicos);
    }

    if (!form.value) return false;

    const invalidField = camposObligatorios.find(
      (campo) => !form.value?.[campo] || form.value?.[campo] === ""
    );
    const hasValidationErrors = Object.values(validationErrors.value).some(
      (error) => error !== null && error !== "" && error !== undefined
    );

    if(form.value.apellido === "Orden público" && form.value?.TipoRolPersonaFisicaID !== "" && form.value?.TipoRolPersonaFisicaID) {
      isFormValid.value = true;
    } else  {
      isFormValid.value = !invalidField && !hasValidationErrors;
    }
    return isFormValid.value;
  };
  const handleRoleChange = async (newRole) => {
    if (!newRole) return;
    const name = newRole.nombre?.toLowerCase().trim();
    if (name === "a determinar") {
      const rol = newRole;
      form.value = emptyForm();
      form.value.TipoRolPersonaFisicaID = rol;
      validationErrors.value = {};
      isFormValid.value = true;
      return;
    }
    
    form.value.TipoRolPersonaFisicaID = newRole;
    
    isFormValid.value = false;
    try {
      await nextTick();
      validateForm();
    } catch (e) {
      console.error("Error al revalidar después de cambiar rol:", e);
    }
  };

  const handlePutAffecteds = async () => {

    if (!validateForm()) return;
    isLoading.value = true;

    const formatedAffected = {
      ActuacionID: "",
      ActuacionPersonaFisicaID: "",
      Apellido: form.value.apellido,
      Celular: "",
      Cuil: form.value.cuil,
      Cuit: form.value?.cuit,
      Denominacion: form.value?.denominacion,
      TipoDocumentoID: form.value.tipoDocumento?.id || "",
      NumeroIdentificacion: form.value.documento,
      DomicilioJuridico: form.value?.domicilioJuridico,
      DomicilioSipe: form.value.domicilio,
      CorreoElectronico: form.value.email || "",
      Email: form.value.email || "",
      EstadoCivil: form.value.civilStatus?.nombre || "",
      FechaDeNacimiento: form.value.fechaNacimiento,
      FechaDefuncion: "",
      FechaDesde: "",
      FechaHasta: "",
      Instruccion: form.value.instruction?.nombre || "",
      LugarDeNacimiento: "",
      Nacionalidad: form.value.nacionality?.nombre || "",
      Nombre: form.value.nombre,
      Observaciones: form.value?.observaciones,
      Orden: "",
      PersonaFisicaID: "",
      PersonaJuridica: false,
      Profesion: form.value.profesion,
      Rubro: form.value?.rubro,
      Sexo: form.value.gender?.nombre || "",
      Telefono: form.value.telefono,
      TelefonoJuridico: form.value?.telefonoJuridico,
      TieneSeguro: form.value?.tieneSeguro === true ? "1" : "0",
      TipoRolPersonaFisicaID: form.value.TipoRolPersonaFisicaID?.nombre || "",
      Identikit: form.value?.Identikit || [],
      coelsa: form.value?.coelsa || [],
    };
    if (isEdit.value) {
      affectedList.value = affectedList.value.map((affected) => {
        if (affected?.PersonaFisicaID === form?.value?.PersonaFisicaID) {
          return {
            ...affected,
            ...formatedAffected,
            CorreoElectronico:
              form.value.email || affected.Email || affected.CorreoElectronico || "",
            Email: form.value.email || affected.Email || affected.CorreoElectronico || "",
          };
        }
        return {
          ...affected,
          CorreoElectronico: affected.Email || affected.CorreoElectronico || "",
          Email: affected.Email || affected.CorreoElectronico || "",
        };
      });
      await handleSave();
    } else if (isCreate.value) {
      handleCreateAffected(formatedAffected);
    }
  };
  
  const handleSaveLocally = async () => {
    if (!validateForm()) return;
    isLoading.value = true;
  
    const formatedAffected = {
      ActuacionPersonaFisicaID: form.value?.ActuacionPersonaFisicaID || `temp-${Date.now()}`,
      Apellido: form.value.apellido,
      Celular: "",
      Cuil: form.value.cuil,
      Cuit: form.value?.cuit,
      Denominacion: form.value?.denominacion,
      TipoDocumentoID: form.value.tipoDocumento?.id || "",
      NumeroIdentificacion: form.value.documento,
      DomicilioJuridico: form.value?.domicilioJuridico,
      DomicilioSipe: form.value.domicilio,
      CorreoElectronico: form.value.email || "",
      Email: form.value.email || "",
      EstadoCivil: form.value.civilStatus?.nombre || "",
      ExhibeDocumento: String(form.value.showDocument?.id),
      FechaDeNacimiento: form.value.fechaNacimiento,
      FechaDefuncion: "",
      FechaDesde: "",
      FechaHasta: "",
      Instruccion: form.value.instruction?.nombre || "",
      LugarDeNacimiento: "",
      Nacionalidad: form.value.nacionality?.nombre || "",
      Nombre: form.value.nombre,
      Observaciones: form.value?.observaciones,
      Orden: "",
      PersonaFisicaID: "",
      PersonaJuridica: false,
      Profesion: form.value.profesion,
      Rubro: form.value?.rubro,
      Sexo: form.value.gender?.nombre || "",
      Telefono: form.value.telefono,
      TelefonoJuridico: form.value?.telefonoJuridico,
      TieneEstudios: String(form.value?.haveStudies?.id),
      TieneSeguro: form.value?.tieneSeguro === true ? "1" : "0",
      TipoRolPersonaFisicaID: form.value.TipoRolPersonaFisicaID?.nombre || "",
      Identikit: form.value?.Identikit || [],
      coelsa: form.value?.coelsa || [],
    };
  
    if (isCreate.value) {
      affectedList.value.push(formatedAffected);
    } else if (isEdit.value) {
      const index = affectedList.value.findIndex(
        (v) => v.ActuacionPersonaFisicaID === form.value.ActuacionPersonaFisicaID
      );
      if (index !== -1) {
        affectedList.value[index] = formatedAffected;
      }
    }
  
    isLoading.value = false;
    startView();
  };

  const handleDeleteAffected = async (locally = false) => {
    isLoading.value = true;
    try {
      const selectedIndexArray = affectedList.value.findIndex(
        (item) => item.ActuacionPersonaFisicaID === selectedId.value
      );
      affectedList.value = affectedList.value.filter(
        (affected) => affected.ActuacionPersonaFisicaID !== selectedId.value
      );
      if (!locally) await handleSave(selectedIndexArray);
    } catch (error) {
      console.error("Error al eliminar afectado", error);
      isLoading.value = false;
      throw error;
    }
  };

  const handleCreateAffected = async (newAffected) => {
    affectedList.value = [
      ...affectedList.value,
      {
        ...newAffected,
      },
    ];
    await handleSave();
  };

  const handleSave = async (indexToRedirect) => {
    // siempre pega al mismo endpoint, solo se modifica el arreglo original
    try {
      const formattedAffectedList = affectedList.value.map((affected) => ({
        ...affected,
        CorreoElectronico: affected.Email || affected.CorreoElectronico || "",
        Email: affected.Email || affected.CorreoElectronico || "",
      }));

      let options = {
        url: `${baseUrl}/${actuacionID.value}`,
        formData: { Afectados: formattedAffectedList },
        ContentType: "text/plain",
      };
      await rest.put(options);
    } catch (error) {
      console.error("Error al editar afectados", error);
    } finally {
      isLoading.value = false;
      if (isCreate.value || isEdit.value) triggerSuccessModal();
      startView();
      if (indexToRedirect !== undefined) clear();
      fetchAffecteds(actuacionID.value, indexToRedirect);
    }
  };

  const select = (affected) => {
    selected.value = affected;
    hydrateFormFromDoc(affected);
    formType.value = "view";
  };

  const startCreate = () => {
    selected.value = null;
    form.value = emptyForm();
    formType.value = "create";
  };

  const hydrateFormFromDoc = (affected) => {
    form.value = {
      tipoDocumento: affected?.TipoDocumentoID || "",
      documento: affected?.NumeroIdentificacion || "",
      gender: { nombre: affected?.Sexo || "" },
      showDocument: affected?.ExhibeDoc || "",
      cuil: affected?.NroCuil || "",
      apellido: affected?.Apellido || "",
      nombre: affected?.Nombre || "",
      edad: affected?.Edad || "",
      fechaNacimiento: affected?.FechaNac || "",
      nacionalidad: { nombre: affected?.Nacionalidad || "" },
      civilStatus: { nombre: affected?.EstadoCivil || "" },
      domicilio: affected?.Domicilio || "",
      telefono: affected?.Telefono || "",
      email: affected?.Email || "",
      profesion: affected?.Profesion || "",
      haveStudies: affected?.TieneEstudios || "",
      instruction: { nombre: affected?.Instruccion || "" },
      observaciones: affected?.Observaciones || "Sin Registros",
      Identikit: affected?.Identikit || [],
      coelsa: affected?.coelsa || [],
    };
  };

  const startEdit = () => {
    formType.value = "edit";
  };
  const startView = () => {
    formType.value = "view";
  };

  const resetForm = () => {
    form.value = emptyForm();
  };

  const clear = () => {
    selected.value = null;
    resetForm();
  };

  const selectFirst = () => {
    if (affectedList.value?.length) {
      select(affectedList.value[0]);
    }
  };

  const selectNextOrPrevious = (indexToRedirect) => {
    if (affectedList.value[indexToRedirect] === undefined) {
      select(affectedList.value[indexToRedirect - 1]);
      return;
    }
    if (affectedList.value?.length) {
      select(affectedList.value[indexToRedirect]);
    }
  };

  const selectedId = computed(() => selected.value?.ActuacionPersonaFisicaID ?? null);

  const isSelected = (id) => selected.value?.ActuacionPersonaFisicaID === id;
  const isView = computed(() => formType.value === "view");
  const isEdit = computed(() => formType.value === "edit");
  const isCreate = computed(() => formType.value === "create");
  const inputsDisabled = computed(() => formType.value === "view");
  const isFormValid = ref(false);
  const validationErrors = ref({});

  const showSuccessModal = ref();

  const setShowSuccessModal = (fn) => {
    showSuccessModal.value = fn;
  };

  const triggerSuccessModal = () => {
    showSuccessModal.value?.();
  };

  const setValidationErrors = (errors) => {
    validationErrors.value = errors;
  };

  return {
    // state
    selected,
    form,
    formType,
    affectedList,
    isLoading,

    // actions
    select,
    hydrateFormFromDoc,
    resetForm,
    clear,
    startCreate,
    startEdit,
    handleSave,
    fetchAffecteds,
    handleCreateAffected,
    handleDeleteAffected,
    handlePutAffecteds,
    handleSaveLocally,
    handleRoleChange,
    startView,
    setShowSuccessModal,
    triggerSuccessModal,
    selectFirst,
    validateForm,
    setValidationErrors,

    // getters
    selectedId,
    isSelected,
    isCreate,
    isEdit,
    isView,
    inputsDisabled,
    isFormValid,
  };
});
